// const useDynamicTableExport = () => {
//   const exportTableToCSV = (containerRef, fileName = "table_export") => {
//     if (!containerRef) return;

//     const table = containerRef.querySelector("table");

//     if (!table) {
//       alert("No table found");
//       return;
//     }

//     const rows = Array.from(table.querySelectorAll("tr"));

//     const csvRows = rows.map((row) => {
//       const cols = Array.from(row.querySelectorAll("th, td"));

//       return cols
//         .map((cell) => {
//           let text = cell.innerText.trim();

//           text = text.replace(/\n/g, " ");
//           text = text.replace(/"/g, '""');

//           return `"${text}"`;
//         })
//         .join(",");
//     });

//     const csv = csvRows.join("\n");

//     const blob = new Blob([csv], {
//       type: "text/csv;charset=utf-8;",
//     });

//     const url = URL.createObjectURL(blob);

//     const link = document.createElement("a");

//     link.href = url;
//     link.download = fileName.replace(/[^a-z0-9]/gi, "_").toLowerCase() + ".csv";

//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);

//     URL.revokeObjectURL(url);
//   };

//   return { exportTableToCSV };
// };

// export default useDynamicTableExport;

const useDynamicTableExport = () => {
  const cleanText = (text = "") => {
    return (
      text
        // Normalize unicode (fix encoding inconsistencies)
        .normalize("NFKC")

        // Replace non-breaking spaces & weird spaces
        .replace(/\u00A0/g, " ")

        // Fix common mojibake sequences
        .replace(/â€‘/g, "-")
        .replace(/â€“/g, "-")
        .replace(/â€”/g, "-")
        .replace(/Î±/g, "α")
        .replace(/Î²/g, "β")

        // Remove line breaks
        .replace(/\r?\n|\r/g, " ")

        // Escape quotes for CSV
        .replace(/"/g, '""')

        .trim()
    );
  };

  const exportTableToCSV = (containerRef, fileName = "table_export") => {
    if (!containerRef) return;

    const table = containerRef.querySelector("table");

    if (!table) {
      console.warn("No table found for export");
      return;
    }

    const rows = Array.from(table.querySelectorAll("tr"));

    const csvRows = rows.map((row) => {
      const cols = Array.from(row.querySelectorAll("th, td"));

      return cols
        .map((cell) => {
          const rawText = cell.textContent || "";
          const cleaned = cleanText(rawText);
          return `"${cleaned}"`;
        })
        .join(",");
    });

    const csvContent = csvRows.join("\n");

    // ✅ Add BOM for Excel UTF-8 support
    const BOM = "\uFEFF";

    const blob = new Blob([BOM + csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;

    link.download = fileName.replace(/[^a-z0-9]/gi, "_").toLowerCase() + ".csv";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  return { exportTableToCSV };
};

export default useDynamicTableExport;
